export default "/images/customers.png?96f4feb5672a82a606b5b2f08eda39b6";